module.exports = __webpack_public_path__ + "img/banner4.2e287c81.jpg";